export enum AssetType {
  CRYPTO = "crypto",
  FIAT = "fiat",
  STABLE = "stable"
}

export interface Asset {
  id: number;
  code: string; // e.g., "USD", "MXN", "BTC"
  name: string; // e.g., "US Dollar", "Mexican Peso", "Bitcoin"
  display_decimals: number; // e.g., 2 for USD, 6 for BTC
  contract_decimals: number; // e.g., 6 for USD (yahoo finance resolution), 8 for BTC (bybit resolution)
  image_url: string | null;
  is_enabled: boolean;
  asset_type: AssetType;
  created_at: string;
}

export interface AssetBase {
  name: string;
  code: string;
  display_decimals: number;
  contract_decimals: number;
  image_url: string;
  asset_type: AssetType;
}

export interface AssetUpdate {
  name?: string;
  code?: string;
  display_decimals?: number;
  contract_decimals?: number;
  image_url?: string;
  is_enabled?: boolean;
  asset_type?: AssetType;
}
